import React, { FunctionComponent } from 'react';
import { Col } from 'react-flexbox-grid';
import { ErrorMessage } from '../../../../../types/interfaces';
import { getTextFactoryReturnType } from '../../../../../utils/TextUtils';
import { ProductFormCheckbox } from '../../../../../components/productFormFields';

type IndividualFirmEmployeeFormGroupProps = {
  getText: getTextFactoryReturnType;
  formatErrorMessage: (error: ErrorMessage) => string;
};

const IndividualFirmEmployeeFormGroup: FunctionComponent<IndividualFirmEmployeeFormGroupProps> = (
  props: IndividualFirmEmployeeFormGroupProps,
) => {
  const { getText, formatErrorMessage } = props;

  return (
    <Col xs={12} md={12} lg={12} data-test="field_investmentFirmEmployeeInd">
      <ProductFormCheckbox
        className="checkbox-form"
        label={getText('individualCheckbox')}
        name="proInvolvement.investmentFirmEmployeeInd"
        formatErrorMessage={formatErrorMessage}
      />
    </Col>
  );
};

export default IndividualFirmEmployeeFormGroup;
